const rootNote = [
  {
    note: "C",
    index: 0
  },
  {
    note: "G",
    index: 7
  },
  {
    note: "D",
    index: 2
  },
  {
    note: "A",
    index: 9
  },
  {
    note: "E",
    index: 4
  },
  {
    note: "B",
    index: 11
  },
  {
    note: "F#",
    index: 6
  },
  {
    note: "Gb",
    index: 6
  },
  {
    note: "Db",
    index: 1
  },
  {
    note: "Ab",
    index: 8
  },
  {
    note: "Eb",
    index: 3
  },
  {
    note: "Bb",
    index: 10
  },
  {
    note: "F",
    index: 5
  }
];

export default rootNote;
